import { render, staticRenderFns } from "./client.vue?vue&type=template&id=5182b917&scoped=true"
import script from "./client.vue?vue&type=script&lang=js"
export * from "./client.vue?vue&type=script&lang=js"
import style0 from "./client.vue?vue&type=style&index=0&id=5182b917&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5182b917",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/account/client.vue
// module id = null
// module chunks = 